import React, { Component } from 'react';
import { 
  Modal,
  Loading,
  DatePicker,
  DatePickerInput 
} from 'carbon-components-react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { TableDefault } from '../../../../components';
import {
  PREPARACAO,
  ENTREGUE,
  PRONTAENTREGA,
  DEVOLVIDO,
  AGUARDANDODEVOLUCAO
} from '../../../../config/StatusRequest';
import { pathDmService } from '../../../../services/Api';


class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      pageSize: 100,
      totalItems: 0,
      typeCleark: 1,
      type: null,
      orderBy: 'DataSolicitacao',
      // orderDirection: '',
      // urlDelete: '/Pedido/Delete',
      urlEdit: '/trade/admin/uniformes/editar/',
      urlLoad: '/Pedido/GetAssistentesAtendente/',
      // messageNextModal: 'Você tem certeza que deseja alterar o status do pedido',
      actionModal: false,
      numberRequest: [],
      statusRequest: null,
      newStatusRequest: null,
      selectedFilter: null,
      dataFilter: {
        itens: [
          { id: 0, label: 'Todos' },
          { id: 1, label: 'Troca' },
          { id: 2, label: 'Novo' }
        ],
        placeholder: 'Filtrar por tipo'
      },
      isSaving: false,
      updateEntregue: false,
      nomeRecebedor: '',
      dataEntrega: null,
      dataBanco: null,
      ids:[],
      id:null
    };
  }

  componentDidMount() {
    this.setSatus("");
  }

  setSatus = status => {
    let newStatus = {};
    switch (status) {
      case 'Pendente':
        newStatus = PREPARACAO;
        break;
      case 'Preparação':
        newStatus = PRONTAENTREGA;
        break;
      case 'Pronto para Entrega':
        newStatus = ENTREGUE;
        break;
      case 'Entregue':
        newStatus = AGUARDANDODEVOLUCAO;
        break;        
      case 'Aguardando Devolução':
        newStatus = DEVOLVIDO;
        break;
      default:
        newStatus = null;
        break;
    }

    this.setState({
      newStatusRequest: newStatus,
      updateEntregue: newStatus && newStatus.value === "Entregue"
    });
  };

  actionNext = event => {

    this.setSatus(event.cells[6].value);
    
    this.setState(prevState => ({
      actionModal: !prevState.actionModal,
      selectedId: null,
      numberRequest: [event.cells[0].value],
      id: event.id,
      statusRequest: event.cells[6].value
    }));
  };

  closeModalNext = () => {
    this.setState({
      actionModal: false
    });
  };

  updateStatus = async () => {
    const { 
      newStatusRequest,
      nomeRecebedor,
      dataBanco,
      ids,
      id
    } = this.state;
    const { match, history } = this.props;
    const url = `Pedido/AtualizaStatusLote/${id || ids.join(',')}?status=${newStatusRequest ? newStatusRequest.id : null}&retirouUniforme=${nomeRecebedor}&dataRetiradaUniforme=${dataBanco}`;
    this.setState({ isSaving: true });

    try {
      await pathDmService(url, {});
      await toast.success('Status atualizado com sucesso.');
      // window.location.href = await match.url
      history.push(match.url)
      await this.setState({ actionModal: false });
    } catch (error) {
      toast.warn('Um erro inesperado ocorreu ao tentar atualizar o status.');
      this.setState({ isSaving: false });
    }
   
  };

    onChangeText = event => {
      this.setState({
        nomeRecebedor: event.target.value
      });
    };

    onChangeDate = date => {
      const newDate = date ? moment(date[0]).format('YYYY-MM-DD HH:mm:ss') : date;    
      this.setState({
        dataEntrega:newDate,
        dataBanco: newDate
      })
    };

    selectedRow = obj => {
      console.log(this.state)
      const numberRequest = []
      if(obj.rows && obj.rows.length > 0) {
        this.setSatus(obj.rows[0].cells[6].value);
        this.setState({statusRequest: obj.rows[0].cells[6].value})
        obj.rows.forEach(item=> {
          numberRequest.push(item.cells[0].value);
        })
      } 
      this.setState({id:null, ids : obj.ids, numberRequest})
    }

  render() {
    const {
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      actionModal,
      numberRequest,
      statusRequest,
      newStatusRequest,
      dataFilter,
      selectedFilter,
      type,
      isSaving,
      typeCleark,
      updateEntregue,
      nomeRecebedor,
      dataEntrega,
      ids
    } = this.state;
    const { defaultFilters, showCheck } = this.props;

    const disabledButtonUpdatStatus = updateEntregue && (dataEntrega === "" || nomeRecebedor === "");
    const currentDate = moment(dataEntrega || new Date()).format("DD/MM/YYYY");
    const rowSelect = {}
    if(showCheck) {
      rowSelect.onRowSelected= rows => {
        this.selectedRow(rows);
      };
    }

    return (
      <div className="table-uniforms">
        {showCheck && (
          <button
            disabled={!(ids && ids.length > 0)}
            className="bx--btn btn-secondary-color h-sm-margin"
            style={{marginBottom:10}}
            type="button"
            onClick={() => this.setState({actionModal:true})}
          >
            Alterar status
          </button>
        )}
        
        <TableDefault
          {...rowSelect}
          search={search}
          defaultFilters={defaultFilters}
          typeCleark={typeCleark}
          type={type}
          order={order}
          orderBy={orderBy}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          idxStatus={6}
          urlLoad={urlLoad}
          actionNext={this.actionNext}
          dataFilter={dataFilter}
          selectedFilter={selectedFilter}
          {...this.props}
        />

        <Modal
          open={actionModal}
          onRequestSubmit={() => this.updateStatus()}
          onRequestClose={() => this.closeModalNext()}
          primaryButtonDisabled={disabledButtonUpdatStatus}
          modalHeading="Alteração de Status"
          primaryButtonText="Confirmar"
          secondaryButtonText="Cancelar"
        >
          {isSaving && <Loading small />}
          <div>
            
            {!updateEntregue ? (
              <div>
                <p>
                  
                  {`Você tem certeza que deseja alterar o status ${numberRequest.length > 1 ? "dos pedidos" : "do pedido"} `}
                  <strong> 
                    {numberRequest.join(', ')}
                  </strong>
                  {' de '}
                  <strong>{statusRequest}</strong>
                  {' para '}
                  <strong>
                    {' '}
                    {newStatusRequest ? newStatusRequest.value : null}
                    {' '}
                  </strong>
                  ?
                </p>
              </div>
            ) : (
              <div className="bx--row">
                <div className="v-sm-margin bx--col-md-12">
                  <p>
                    {`Você tem certeza que deseja alterar o status ${numberRequest.length > 1 ? "dos pedidos" : "do pedido"} `}
                    <strong> 
                      {' '}
                      {numberRequest.join(',')}
                      {' '}
                    </strong>
                    {' de '}
                    <strong>{statusRequest}</strong>
                    {' para '}
                    <strong>
                      {' '}
                      {newStatusRequest ? newStatusRequest.value : null}
                      {' '}
                    </strong>
                    ?
                  </p>
                </div>
                <div className="v-sm-margin bx--col-md-3 bx--col-xs-12">
                  <DatePicker
                    id="date-pickerI"
                    className=""
                    datePickerType="single"
                    dateFormat="d/m/Y"
                    locale="pt"
                    onChange={e => this.onChangeDate(e)}
                    value={currentDate}
                  >
                    <div>
                      <DatePickerInput
                        name="dataEntrega"
                        id="dataEntrega"
                        labelText="Data da entrega"
                        placeholder="dd/mm/aaaa"
                        onChange={e => this.onChangeDate(e)}
                        value={currentDate}
                      />
                    </div>
                  </DatePicker>
                </div>

                <div className="v-sm-margin  bx--col-md-9 bx--col-xs-12">
                  <label className="bx--label">Recebido por:</label>
                  <input
                    type="razaoSocial"
                    className="bx--text-input"
                    required
                    placeholder="Nome do recebedor"
                    name="razaoSocial"
                    value={nomeRecebedor}
                    onChange={this.onChangeText}
                  />
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
export default Items;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Uniforms/Items.js